/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-dialog-title[_ngcontent-%COMP%]{position:relative;z-index:2}.mat-dialog-title[_ngcontent-%COMP%]   mat-toolbar[_ngcontent-%COMP%]{margin:-24px -24px -20px;width:auto}.show-loop-link[_ngcontent-%COMP%]{color:#337ab7;cursor:pointer;text-decoration:underline;margin-right:25px}"];
export { styles as styles };
